var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVirtualBackgroundDelete = function SvgVirtualBackgroundDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 4,
    fill: "#0E0E0E",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 4-6 6M4 4l6 6",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgVirtualBackgroundDelete;